// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_21MVQ","visuallyhidden":"_3P_wC","hide-text":"ekMC9","center":"_3g-ZF","noprint":"_3vme_","innerContainer":"_2dStf","mastheadExtension":"_1nmGi","mastheadExtension-isOpen":"_7poPV _1nmGi"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/MastheadExtension.scss
 ** module id = 964
 ** module chunks = 1
 **/